module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("BAagz"))).then(() => module.bundle.root('hEqeo'));